import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IImportAnnotationsStore } from '../../../../importAnnotations.store';
import { UnregisteredUsersSummaryPane } from './UnregisteredUsersSummaryPane';

export const UnregisteredUsersSummaryPaneContainer = observer((): ReactElement | null => {
  const store = useInjection(IImportAnnotationsStore.$);

  if (!store.report || store.report.unregisteredUsers.length === 0) {
    return null;
  }

  return <UnregisteredUsersSummaryPane unregisteredUsers={store.report.unregisteredUsers} />;
});
